import React, { createContext, useContext, useMemo } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';
import { translations } from '../data/translations';

const LanguageContext = createContext();

export const useLanguage = () => {
  const context = useContext(LanguageContext);
  if (!context) {
    throw new Error('useLanguage must be used within LanguageProvider');
  }
  return context;
};

export const LanguageProvider = ({ children }) => {
  const location = useLocation();
  const navigate = useNavigate();

  // Определяем язык по URL
  const language = useMemo(() => {
    return location.pathname.startsWith('/ru') ? 'ru' : 'en';
  }, [location.pathname]);

  const toggleLanguage = () => {
    const currentPath = location.pathname;
    
    if (language === 'en') {
      // Переключаем на русский - добавляем /ru
      navigate('/ru' + currentPath);
    } else {
      // Переключаем на английский - убираем /ru
      const newPath = currentPath.replace(/^\/ru/, '') || '/';
      navigate(newPath);
    }
  };

  const t = (key) => {
    const keys = key.split('.');
    let value = translations[language];
    
    for (const k of keys) {
      value = value?.[k];
    }
    
    return value || key;
  };

  return (
    <LanguageContext.Provider value={{ language, toggleLanguage, t }}>
      {children}
    </LanguageContext.Provider>
  );
};
